import React from 'react';

import { ChannelEnum } from 'modules/auth/types/LoginRequest';
import { useSendGateMFAMutation } from 'modules/gates/service';
import { getGateMFAData } from 'modules/gates/selectors';
import SelectCommunicationChannelModal from 'components/Communication/SelectCommunicationChannelModal';
import { useSelector } from 'hooks';
import { getSelectedLanguage } from 'modules/translations/selectors';

interface ResendGateCodeModalProps {
  onClose: (isOpen: boolean) => void;
}

const ResendGateCodeModal: React.FC<ResendGateCodeModalProps> = ({ onClose }) => {
  const mfaData = useSelector(getGateMFAData);
  const language = useSelector(getSelectedLanguage);
  const [sendGateMFA] = useSendGateMFAMutation();

  const handleResend = React.useCallback(async (channel: ChannelEnum) => {
    if (mfaData) {
      await sendGateMFA({
        gateId: mfaData.gateId,
        connectionId: mfaData.connectionId,
        phoneNumber: mfaData.phoneNumber,
        channel,
        language,
      }).unwrap();
    }
  }, [mfaData, sendGateMFA, language]);

  return (
    <SelectCommunicationChannelModal
      data={mfaData}
      onSubmit={handleResend}
      onClose={onClose}
      blackListChannels={[ChannelEnum.EMAIL, ChannelEnum.WHATSAPP]}
      maxAttemptReached={mfaData?.remainingCode === 0}
      title={{
        id: 'login.resend.title',
        defaultMessage: 'Resend code',
      }}
      message={{
        id: 'login.resend.tryAgain',
        defaultMessage: 'Resend the code via the same channel or switch to another channel available in your file.',
      }}
      sendToChannelMessage={{
        id: 'login.resend.resend',
        defaultMessage: 'Send to {channel}',
      }}
      withCountdown
    />
  );
};

export default ResendGateCodeModal;
